module.exports = __webpack_public_path__ + "static/media/personal-values@3x.876b5a1a.png";